import { MAP_TOOLS } from '../../../lib/constants';

export default (dispatch) => ({
  enableLineMeasurement: () => {
    dispatch({
      type: 'map/resetWidgetState',
    });
    dispatch({
      type: 'map/enableLineMeasurement'
    });
    dispatch({
      type: 'map/setActiveTool',
      payload: MAP_TOOLS.Measure,
    });
  },

  setMeasurementWidgetRef: (ref) => {
    dispatch({
      type: 'map/setMeasurementWidgetRef',
      payload: ref
    });
  },

  clearMeasurements: () => {
    dispatch({
      type: 'map/resetWidgetState'
    });
  }
});